import { render, staticRenderFns } from "./AuthResetPasswordDialog.vue?vue&type=template&id=57c3eba3&scoped=true&"
import script from "./AuthResetPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./AuthResetPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c3eba3",
  null
  
)

export default component.exports